
import { Box2, Vector2 } from "three";
import { Line2 } from "../../../library-js/geometry/Line2";
import { NodeGraphComponent } from "./NodeGraphComponent";
import { NodeGraphReference } from "./NodeGraphReference";

export class NodeGraphEdge extends NodeGraphReference
{
  _fromConnector:NodeGraphComponent;
  _toConnector:NodeGraphComponent;
  _hovered:boolean = false;

  get start()
  {
    return this._fromConnector._outputConnectorPosition;
  }

  get end()
  {
    return this._toConnector._inputConnectorPosition;
  }

  getDistance( p:Vector2 )
  {
    let start = this._fromConnector._outputConnectorPosition;
    let end   = this._toConnector._inputConnectorPosition;
    
    let line2 = new Line2( start, end );

    return line2.distanceToPoint( p );
  }
  
  setHoverState( state:boolean )
  { 
    this._hovered = state;
  }
}